"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OuterSubscriber = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Subscriber2 = require("./Subscriber");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(OuterSubscriber, _Subscriber);

  function OuterSubscriber() {
    (0, _classCallCheck2.default)(this, OuterSubscriber);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OuterSubscriber).apply(this, arguments));
  }

  (0, _createClass2.default)(OuterSubscriber, [{
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      this.destination.next(innerValue);
    }
  }, {
    key: "notifyError",
    value: function notifyError(error, innerSub) {
      this.destination.error(error);
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete(innerSub) {
      this.destination.complete();
    }
  }]);
  return OuterSubscriber;
}(_Subscriber2.Subscriber);

exports.OuterSubscriber = OuterSubscriber;